import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Typed from 'typed.js';
import './AboutText.css';

const AboutText = () => {
  const typedRef = useRef(null);
  const typedInstance = useRef(null);
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    // Intersection Observer für Scroll-Trigger
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Nur wenn Element sichtbar ist und noch nicht animiert wurde
          if (entry.isIntersecting && !hasAnimated && typedRef.current) {
            setHasAnimated(true);
            
            // Typing-Effekt starten
            setTimeout(() => {
              if (typedRef.current && !typedInstance.current) {
                const options = {
                  strings: ['How much longer do you want to wait?'],
                  typeSpeed: 20,
                  startDelay: 100,
                  showCursor: false,
                  autoInsertCss: true,
                };

                typedInstance.current = new Typed(typedRef.current, options);
              }
            }, 100);
          }
        });
      },
      {
        threshold: 0.2, // Startet wenn 20% der Sektion sichtbar ist
        rootMargin: '0px'
      }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    // Cleanup beim Unmount
    return () => {
      if (typedInstance.current) {
        typedInstance.current.destroy();
        typedInstance.current = null;
      }
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [hasAnimated]);

  return (
    <section className="about-text-at" ref={sectionRef}>
      {/* Logo */}
      <img 
        src="/img/salesgod_logo_hell.webp" 
        alt="SalesGod Logo" 
        className="about-text-at-logo"
      />
      
      {/* Background Image Container */}
      <div className="about-text-at-image-section">
        <img 
          src="/img/julian_1.jpg" 
          alt="Julian Propst" 
          className="about-text-at-background-image"
        />
      </div>
      
      {/* Multi-Layer Blur Transition */}
      <div className="about-text-at-blur-layer about-text-at-blur-1"></div>
      <div className="about-text-at-blur-layer about-text-at-blur-2"></div>
      <div className="about-text-at-blur-layer about-text-at-blur-3"></div>
      <div className="about-text-at-blur-layer about-text-at-blur-4"></div>
      <div className="about-text-at-blur-layer about-text-at-blur-5"></div>
      
      {/* Content */}
      <div className="about-text-at-container">
        <div className="about-text-at-content">
          <div className="about-text-at-text">
            <h2 className="about-text-at-title">The Digital Renaissance is now.</h2>
            <h3 className="about-text-at-title-special" ref={typedRef}></h3>
            <div className="about-text-at-divider"></div>

<div className="about-text-at-paragraphs">              
  <p>I know how it feels when you give everything – and it still doesn't work out.</p>
  
  <p>When you have a vision that keeps you up at night - but you don't know where to start.</p>
  
  <p>I always wanted to build my own business. I had ideas, energy, and perseverance – but no system.</p>
  
  <p>So I tried everything there is to try – and failed countless times along the way.</p>
  
  <p className="about-text-at-bold">I learned that the foundation of a successful business is always a strong product – 
  only to realize that the best product is worthless if no one knows about it.</p>
  
  <p>I know the feeling of dreaming and doubting simultaneously, yet continuing anyway because giving up is not an option.</p>
  
  <p className="about-text-at-emphasis">Those years shaped me.</p>
  
  <p>They showed me what actually works and what just drains energy without delivering results.</p>
  
  <p>I understood that success doesn't come from working more, but from <span className="about-text-at-highlight">doing the right things – clearly, purposefully, and with a system.</span></p>
  
  <p className="about-text-at-emphasis">Today I help people who carry the same fire within them.</p>
  
  <p>Entrepreneurs, creatives, and brands who want to bring something real into the world – and are ready to act now, instead of waiting longer for the "right moment."</p>
  
  <p>With my team, I support them in turning their vision into clear structure and excellent execution – so that ideas become results.</p>

  <p className="about-text-at-bold">Because there's no better time than now – and no bigger mistake than waiting any longer.</p>
</div>

            
            <Link to="/julian" className="about-text-at-button">
              <span>More about Julian's Projects</span>
              <img src="/img/down.svg" alt="Arrow" className="about-text-at-button-arrow" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutText;
